document.addEventListener('DOMContentLoaded', (event) => {
    const cvsElement = document.querySelector('.cvs-items.swiper-container');
    let slidesPerView = 'auto';
    
    if (cvsElement.classList.contains('alone')) {
        slidesPerView = 1;
    }

    var cvsSwipes = new Swiper('.cvs .cvs-items.swiper-container', {
        loop: false,
        slidesPerView: slidesPerView,
        centeredSlides: false,
        spaceBetween: 12,
        pagination: {
            el: '.cvs .swiper-pagination',
            clickable: true,
        },
        scrollbar: {
            el: '.cvs .swiper-scrollbar',
            draggable: true,
        },
        navigation: {
            nextEl: '.cvs .swiper-next-btn',
            prevEl: '.cvs .swiper-prev-btn',
        },
        breakpoints: {
            819: {
                spaceBetween: 12,
            },
            1279: {
                spaceBetween: 16,
                centeredSlides: false,
            },
            1919: {
                spaceBetween: 30,
                centeredSlides: false,
            },
            3000: {
                spaceBetween: 40,
                centeredSlides: true,
            }
        }
    });
});